import { fetcher } from '@commenda/utils';
import { BASE_URL } from './helpers';
import { FormsTemplateResponse } from './types';

/**
 * Fetch a single form template by ID
 */
export async function getFormsTemplate(
  templateId: string
): Promise<{ success: boolean; data?: FormsTemplateResponse }> {
  try {
    const res = await fetcher(`${BASE_URL}/${templateId}`, {
      method: 'GET',
    });

    if (!res.ok) {
      console.error('Failed to get form template:', await res.text());
      return { success: false };
    }

    const responseData = (await res.json()) as FormsTemplateResponse;
    return {
      success: true,
      data: responseData,
    };
  } catch (err) {
    console.error('Error getting form template:', err);
    return { success: false };
  }
}
